export const innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 5L1 19H8.5L9.14062 13.875H14.8594L15.5 19H23L17.25 5H13.75L14.3906 10.125H9.60938L10.25 5H6.75Z" fill="#F8C617"/>
</svg>
`
